export const HORSING = 'horsing'
export const DRYING_TEARS = 'dryingTears'
